module.exports = __webpack_public_path__ + "img/multi_user_selected.13dd826a.svg";